if (!customElements.get('auto-add-to-cart')) {
  customElements.define('auto-add-to-cart', class AutoAddToCart extends HTMLElement {
    connectedCallback() {
      this.sourceVariantIds = JSON.parse(this.dataset.sourceVariantIds);
      this.targetVariantId = parseInt(this.dataset.targetVariantId);
      this.quantity = parseInt(this.dataset.quantity) || 1;

      this.cartElement = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate.bind(this));
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    onCartUpdate(event) {
      if (event.source !== 'product-form') return;
      const addedVariantId = parseInt(event.productVariantId);
      console.log('[auto-add-to-cart] cartUpdate fired. addedVariantId:', addedVariantId, '| sourceVariantIds:', this.sourceVariantIds);
      if (!this.sourceVariantIds.includes(addedVariantId)) {
        console.log('[auto-add-to-cart] variant not in source list, skipping');
        return;
      }

      this.addTargetProduct();
    }

    async addTargetProduct() {
      try {
        // Skip if target is already in cart
        const cart = await fetch('/cart.js').then((r) => r.json());
        const alreadyInCart = cart.items.some((item) => item.variant_id === this.targetVariantId);
        console.log('[auto-add-to-cart] alreadyInCart:', alreadyInCart, '| targetVariantId:', this.targetVariantId);
        if (alreadyInCart) return;

        const body = { items: [{ id: this.targetVariantId, quantity: this.quantity }] };
        if (this.cartElement) {
          body.sections = this.cartElement.getSectionsToRender().map((s) => s.id);
          body.sections_url = window.location.pathname;
        }

        console.log('[auto-add-to-cart] posting to /cart/add.js with body:', body);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        }).then((r) => r.json());

        console.log('[auto-add-to-cart] /cart/add.js response:', response);

        if (response.status) {
          console.error('[auto-add-to-cart] Failed to add product:', response.description);
          return;
        }

        if (this.cartElement) {
          this.cartElement.renderContents(response);
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'auto-add-to-cart',
          productVariantId: this.targetVariantId,
        });
      } catch (e) {
        console.error('[auto-add-to-cart] Unexpected error:', e);
      }
    }
  });
}
